import { types } from "../types/types";


const initialState = {
    orders: [],
    activeOrder: null,
    ordersGroupMerchant: {},
    statusCounts: {},
    ordersMerchantSelected: [],
    ordersSelected: [],
    multipleassignOrders: false
}

export const ordersReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.ordersLoading:
            return {
                ...state,
                orders:[...action.payload.orders],
                ordersGroupMerchant: action.payload.group,
                statusCounts:action.payload.statusCounts
            }
        case types.ordersMerchantSelected:
            return {
                ...state,
                ordersMerchantSelected: action.payload
            }
        case types.orderActiveSelected:
            return {
                ...state,
                activeOrder:action.payload
            }
        case types.orderActiveClear:
            return {
                ...state,
                activeOrder:null
            }
        case types.driverClearAll:
            return {
                ...state,
                ordersAsigned: [],
                ordersUnasigned: [],
                activeOrder: null
            }
        case types.ordersSelected:
            return {
                ...state,
                ordersSelected: action.payload
            }
        case types.clearOrdersSelected:
            return {
                ...state,
                ordersSelected: []
            }
        case types.multipleassignOrders:
            return {
                ...state,
                multipleassignOrders: action.payload
            }
        default:
            return state;
    }
}